export default __webpack_public_path__ + "static/media/shape-push_up_challenge.64c23c05.jpg";